module.exports = __webpack_public_path__ + "static/img/715_phase_function_Paper_Points.0d77913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/715_phase_function_Paper_Points.png
// module id = CL7X
// module chunks = 0